import React from 'react'

import SelectField from './SelectField'

// Lets the donor pick which org's wallet receives the donation when a
// fundraiser is split across multiple beneficiaries. The first option is
// the parent goal_partner_item — labeled "Split among nonprofits" by
// default, or "Choose a nonprofit" when the partner has disabled splits.
// Picking that pseudo-option is invalid in disable_donation_split mode and
// surfaces an error via useBeneficiarySelect.validate().
const PartnerItemSelect = ({
  i18n, partnerItem, setPartnerItem, partnerItems, goalPartnerItem,
  disableDonationSplit, error,
}) => {
  const handleChange = e =>
    setPartnerItem(partnerItems.concat(goalPartnerItem).find(pi =>
      pi.external_id == e.target.value
    ))

  return (
    <SelectField
      id="partner-item"
      label={i18n.t('beneficiary')}
      error={error}
      value={partnerItem?.external_id || ''}
      onChange={handleChange}
      disabled={partnerItems.length == 1}
      data-plg-donor-field="partnerItem"
    >
      <option value={goalPartnerItem.external_id}>
        {i18n.t(disableDonationSplit ? 'choose_nonprofit' : 'split_among_nonprofits')}
      </option>
      {partnerItems.map(pi => (
        <option key={pi.external_id} value={pi.external_id}>
          {pi.beneficiary.name}
        </option>
      ))}
    </SelectField>
  )
}

export default PartnerItemSelect
